import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-close';
export var ID = 'icon-close';
/* eslint-disable max-len */

export var SVGClose = function SVGClose() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 15 16"
  }, React.createElement("path", {
    d: "M7.425 6.51L1.762.848C1.382.468.744.463.354.854c-.394.393-.394 1.02-.006 1.408L6.01 7.925.348 13.587c-.38.38-.385 1.018.006 1.41.393.392 1.02.392 1.408.004l5.663-5.66L13.087 15c.38.38 1.018.386 1.41-.004.392-.394.392-1.02.004-1.41l-5.66-5.66L14.5 2.26c.38-.38.386-1.018-.004-1.408-.394-.394-1.02-.394-1.41-.006L7.427 6.51z",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var Close = function Close(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGClose
  });
};

Close.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Close;